"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var user = _interopRequireWildcard(require("@/api/user"));
var _role = require("@/api/role");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["token"])),
  props: {
    dialogDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var validateEmail = function validateEmail(rule, value, callback) {
      if (!value) {
        callback(new Error("Vui lòng nhập email"));
      } else if (!(0, _validate.validEmail)(value)) {
        callback(new Error("Email không hợp lệ"));
      } else {
        callback();
      }
    };
    return {
      dialogLoading: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      tempData: {},
      avatar: "",
      dialogStatus: "",
      dialogVisible: false,
      loadingButton: false,
      roles: [],
      roleId: 1,
      rules: {
        name: {
          required: true,
          message: "Vui lòng nhập tên",
          trigger: "submit"
        },
        username: {
          required: true,
          message: "Vui lòng nhập username",
          trigger: "submit"
        },
        password: {
          required: true,
          message: "Vui lòng nhập mật khẩu",
          trigger: "submit"
        }
        // phone: {
        //   required: true,
        //   message: "Vui lòng nhập số điện thoại",
        //   trigger: "submit"
        // },
        // email: {
        //   required: true,
        //   trigger: "submit",
        //   validator: validateEmail
        // }
      }
    };
  },
  created: function created() {
    this.getRoleData();
  },
  methods: {
    handleReset: function handleReset() {
      var _this = this;
      this.$prompt("Enter new password", "Reset password", {
        confirmButtonText: "Reset",
        cancelButtonText: "Cancel"
      }).then(function (_ref) {
        var value = _ref.value;
        var data = {
          newPassword: value
        };
        user.reset(_this.tempData.id, data).then(function (res) {
          _this.$notify.success({
            title: "Reset password",
            message: "Successfully"
          });
        });
      });
    },
    handleUnBlock: function handleUnBlock() {
      var _this2 = this;
      this.$confirm("Confirm unblock this staff?", "Warning", {
        confirmButtonText: "Unblock",
        cancelButtonText: "Cancel",
        type: "warning"
      }).then(function () {
        var data = {
          staff: {
            isBlock: false
          }
        };
        user.update(_this2.tempData.id, data).then(function () {
          _this2.$notify.success({
            title: "Unblock staff",
            message: "Successfully"
          });
          _this2.dialogVisible = false;
          _this2.$emit("submit:success");
        });
      });
    },
    handleBlock: function handleBlock() {
      var _this3 = this;
      this.$confirm("Confirm block this staff?", "Warning", {
        confirmButtonText: "Block",
        cancelButtonText: "Block",
        type: "warning"
      }).then(function () {
        var data = {
          staff: {
            isBlock: true
          }
        };
        user.update(_this3.tempData.id, data).then(function () {
          _this3.$notify.success({
            title: "Block staff",
            message: "Successfully"
          });
          _this3.dialogVisible = false;
          _this3.$emit("submit:success");
        });
      });
    },
    handleDelete: function handleDelete() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this4.$confirm("Confirm delete this staff?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              _this4.loadingButton = true;
              _context.next = 6;
              return user.remove(_this4.form.id);
            case 6:
              _this4.$notify.success({
                title: "Delete Staff",
                message: "Successfully"
              });
              _this4.visible = false;
              _this4.$emit("submit:success");
            case 9:
              _context.prev = 9;
              _this4.loadingButton = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0,, 9, 12]]);
      }))();
    },
    editData: function editData() {
      var _this5 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var data = {
            staff: _this5.tempData,
            roleId: _this5.roleId
          };
          _this5.loadingButton = true;
          user.update(_this5.tempData.id, data).then(function (res) {
            if (res.status) {
              _this5.$notify.success({
                title: "Update Staff",
                message: "Successfully"
              });
              _this5.dialogVisible = false;
              _this5.$emit("submit:success");
            }
          }).finally(function () {
            _this5.loadingButton = false;
          });
        }
      });
    },
    getRoleData: function getRoleData() {
      var _this6 = this;
      (0, _role.getRoles)().then(function (res) {
        _this6.roles = res.data;
      });
    },
    handleEdit: function handleEdit(data) {
      var _this7 = this;
      this.dialogStatus = "edit";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this7.$refs["dataForm"].clearValidate();
        _this7.tempData = (0, _objectSpread2.default)({}, data);
        _this7.roleId = data.role && data.role.id;
      });
    },
    handleAdd: function handleAdd() {
      this.dialogVisible = true;
      this.dialogStatus = "add";
      this.tempData = {};
    },
    createData: function createData() {
      var _this8 = this;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          var data = {
            roleId: _this8.roleId,
            staff: _this8.tempData
          };
          _this8.loadingButton = true;
          user.add(data).then(function (res) {
            if (res.status) {
              _this8.$notify.success({
                title: "Create Staff",
                message: "Successfully"
              });
              _this8.dialogVisible = false;
              _this8.$emit("submit:success");
            }
          }).finally(function () {
            _this8.loadingButton = false;
          });
        }
      });
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.dialogLoading = false;
      this.tempData.avatar = res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      this.dialogLoading = true;
      var isJPG = file.type.includes("image");
      var isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.dialogLoading = false;
        this.$message.error("Avatar picture must be image format!");
      }
      if (!isLt2M) {
        this.dialogLoading = false;
        this.$message.error("Avatar picture size can not exceed 5MB!");
      }
      return isJPG && isLt2M;
    },
    getData: function getData(userId) {
      var _this9 = this;
      this.dialogVisible = true;
      this.dialogStatus = "edit";
      user.findOne(userId).then(function (res) {
        _this9.tempData = res.data;
      });
    }
  }
};